module.exports = __webpack_public_path__ + "static/media/paypal.cda216fe.png";